import getPracticeTimezone from './getPracticeTimezone';

export default function getInitialCalendarPreferences(practice) {
  const defaultTimezone = getPracticeTimezone(practice);

  return {
    selectedTimezones: [defaultTimezone],
    timeScale: 60,
    showWeekends: true,
    showWeekNumbers: true,
    firstDayOfWeek: 1,
    selectedTasks: ['requested', 'in progress', 'completed'],
    visibleCalendars: [],
    defaultView: practice?.display_settings?.calendar?.defaultView?.value || 'day',
    rangeType: 'week',
    defaultLayoutStyle: 'compact',
    calendar_timezones: [{ timezone: defaultTimezone?.value, label: '' }],
    selectedProviders: [],
    selectedLocations: [],
    excludedLocations: [],
    prioritizeServiceColor: false
  };
}
